import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Embed } from './embed.presentation';
import { getDocumentIfNeeded } from '../../actions/document.action';
import { Store } from '../../store/';
import { Alert } from '../common/alert/alert.presentation';

interface Props {
    html: string;
    loading: boolean;
    error: string;
    dispatch: any;
    match: any;
}

class EmbedComponent extends React.Component<Props> {
    componentDidMount() {
        const id = this.props.match.params.id;

        this.props.dispatch(getDocumentIfNeeded(id));
    }

    render() {
        if (this.props.error) {
            return (<div className='container'>
                <Alert message={this.props.error} type='negative' />
            </div>);
        }

        return <Embed html={this.props.html} loading={this.props.loading} />;
    }
}

const mapStateToProps = (state: Store, ownProps) => {
    const id = ownProps.match.params.id;

    return {
        html: typeof state.embeddedDocs.documents[id] !== 'undefined' ? state.embeddedDocs.documents[id] : null,
        loading: state.embeddedDocs.isFetching || !state.embeddedDocs.loaded,
        error: state.embeddedDocs.error
    };
};

const Downloads = withRouter(connect(mapStateToProps)(EmbedComponent));

export default Downloads;



// WEBPACK FOOTER //
// ./src/components/embed/embed.component.tsx